import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ServiceOffersService } from "../../../_services/serviceoffers.service";
import { CustomersService } from "../../../_services/customers.service";
import { KmCatchUpAgreementService } from "../../../_services/matrix/products/km-catch-up-agreement.service";
import { ServiceAddonsService } from "../../../_services/serviceaddons.service";
import { StatisticsService } from '../../../_services/statistics.service';
import { StatisticEvent } from "../../../_models/statisticevent";
import { Customer } from "../../../_models/customer";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CookieService } from 'ngx-cookie';
import { Subscription } from "rxjs";
import { ToasterService, ToasterConfig } from "angular2-toaster/angular2-toaster";
import { Car, UsedCarAgreement } from "app/_models";
import { DealersService } from "app/_services/dealers.service";
import { MatrixCalculatorService } from "app/_services/matrix/matrix-calculator.service";
import { MatrixCarService } from "app/_services/matrix/matrix-cars.service";
import { Dealer } from "app/_models/dealer";
import { differenceInDays } from "date-fns";
import { KmCatchUpAgreement } from "app/_models/kmCatchUpAgreement";
import { MonitorKmService } from "app/_services/monitorkm.service";
import { vehicleKmRecord } from "app/_models/vehicleKmRecord";

@Component({
  selector: "app-km-catch-up-calculator",
  templateUrl: "./calculator.component.html",
  providers: [
    KmCatchUpAgreementService,
    CustomersService,
    DealersService,
    MatrixCalculatorService,
    MatrixCarService,
    ServiceOffersService,
    ServiceAddonsService,
    StatisticsService,
    CookieService,
    MonitorKmService,
  ],
})
export class KmCatchUpCalculatorComponent implements OnInit {
  public showMain: boolean = false;
  private customer: Customer;
  public hasResponded: boolean = false;
  public usedcar: Car;

  private regnr: string = "";
  private usedCarId: string = "";
  private customerid: string = "";
  private mauticId: string = "";
  private dealer: Dealer;
  private kmRecordId: string = "";
  private kmRecord: vehicleKmRecord;

  private errorMessage: string = "";
  private isLoading: boolean = true;

  public kmExceeded: number = 0;
  public monthsNeeded: number = 0;
  public calculatedPrice: number = 0;
  private payment_method: string = "";
  public startupPrice: number = 0;
  public kmPerYear: number = 15000;
  
  private mauticCustomer: any;
  private subscription: Subscription;
  private startDate: Date;
  private estimatedKms: number;

  public agreementStartDate: Date;
  public contactDealerAlert: boolean = false;

  // Add missing properties for template
  public extendOptions: any[] = [];
  public isActive: number = -1;

  // Add new properties for available options
  public options: any = {
    yearStep: [],
    kmStep: []
  };
  public yearSelected: string = "1";
  public kmSelected: number = 15000;
  public firstOptions: any;

  private cookieService: CookieService;
  private toasterService: ToasterService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  constructor(
    toasterService: ToasterService,
    private activatedRoute: ActivatedRoute,
    private kmCatchUpAgreementService: KmCatchUpAgreementService,
    private customersService: CustomersService,
    cookieService: CookieService,
    private dealerService: DealersService,
    private matrixCalculatorService: MatrixCalculatorService,
    private matrixCarService: MatrixCarService,
    private modalService: NgbModal,
    private router: Router,
    private serviceAddonsService: ServiceAddonsService,
    private serviceoffersService: ServiceOffersService,
    private statisticsService: StatisticsService,
    private monitorKmService: MonitorKmService
  ) {
    this.toasterService = toasterService;
    this.cookieService = cookieService;
  }

  ngOnInit() {
    this.isLoading = true;
    this.subscription = this.activatedRoute.params.subscribe(
      (params: any) => {
        this.customerid = params["id"];
        this.kmRecordId = params["record"] as string;
        console.log('Customer ID from route:', this.customerid);

        this.customersService.get(this.customerid).subscribe(
          (c) => {
            this.customer = c;
            this.usedCarId = c.usedCarId;
            if (c.regnr != null && c.regnr != "") {
              this.regnr = c.regnr.toString();
            }
            console.log(this.customer);
          },
          (e) => {
            this.errorMessage = e;
          },
          () => {
            this.matrixCarService.getCar(this.usedCarId).subscribe(
              (c) => {
                this.usedcar = c;
                console.log(this.usedcar);
              },
              (e) => (this.errorMessage = e)
            );

            this.dealerService.get(this.customer.dealer[0] as any).subscribe(
              (d) => {
                this.dealer = d;
                console.log(this.dealer);
                this.payment_method = d.payment_method;
              },
              (e) => (this.errorMessage = e),
              async () => {
                // Fetch vehicle km records for the customer
                try {
                  this.kmRecord = await this.monitorKmService.get(this.kmRecordId);
                  console.log('KM Record received:', this.kmRecord);
                  this.calculateExceededKilometers();
                  console.log(this.customer);
                } catch (error) {
                  console.error('Error fetching km record:', error);
                  this.errorMessage = error;
                  this.isLoading = false;
                }
              }
            );
          }
        );
      }
    );
  }

  calculateExceededKilometers() {
    // Use the already calculated exceeded kilometers from the km record
    this.kmExceeded = this.kmRecord.kmDifference || 0;

    // Ensure kmExceeded is not negative
    if (this.kmExceeded < 0) {
      this.kmExceeded = 0;
    }

    // Use the pre-calculated km driven per year from the km record
    this.kmSelected = this.kmRecord.kmDrivenPerYear || 15000;

    // Initialize with reasonable default values
    this.yearSelected = "1";

    // Update available options - year options first, then km options
    this.updateAvailableYears();
  }

  calculateCatchUpPrice() {
    // Calculate monthsNeeded for internal use and kmPerYear from selected values
    this.monthsNeeded = parseFloat(this.yearSelected) * 12;
    this.kmPerYear = this.kmSelected;

    // Calculate price based on exceeded kilometers and catch-up period
    this.matrixCalculatorService
      .getUsedCarMonthlyPrice(
        this.usedCarId,
        this.yearSelected, // Pass years as string, not months
        Math.round(this.kmPerYear),
        new Date(this.customer.lastservice),
        new Date(this.customer.firstreg),
        this.kmRecord.actualKm
      )
      .subscribe(
        (p) => {
          this.calculatedPrice = p.monthlyPrice;
          // Store the calculation details for checkout
          const catchUpDetails = {
            kmExceeded: this.kmExceeded,
            monthsNeeded: this.monthsNeeded,
            monthlyPrice: this.calculatedPrice,
            totalPrice: this.calculatedPrice * this.monthsNeeded
          };
          sessionStorage.setItem("kmCatchUpDetails", JSON.stringify(catchUpDetails));
          this.isLoading = false;
        },
        (e) => {
          this.errorMessage = e;
          this.isLoading = false;
        }
      );
  }

  updateAvailableYears() {
    this.options.yearStep = [];
    this.matrixCalculatorService
      .getAgreementLengths({
        carId: this.usedCarId,
        agreementStartDate: new Date(this.customer.lastservice),
        firstreg: new Date(this.customer.firstreg),
        maxKms: this.dealer.maxKms,
        maxLength: this.dealer.maxYears,
        selectedKms: this.kmSelected,
        carKms: (this.customer.actualkm as number) - (this.kmExceeded as number),
        showPartialYears: true,
        untilDate: new Date(this.customer.lastservice),
        currentAgreementKms: this.customer.serviceAgreeKm
      })
              .subscribe(
          (p) => {
            // Ensure p.ages is an array
            if (!p.ages || !Array.isArray(p.ages)) {
              this.options.yearStep = ["1"]; // Fallback to default
              this.firstOptions = [...this.options.yearStep];
              return;
            }
            
            // Filter out invalid year options (allow decimal values for partial years)
            this.options.yearStep = p.ages.filter(age => age != null && age !== undefined && Number(age) > 0 && !isNaN(Number(age)));
            this.firstOptions = [...this.options.yearStep];
          
          if (this.options.yearStep.length) {
            const foundSelection = this.options.yearStep.find(
              (length) => `${length}` === this.yearSelected
            );
            
            if (foundSelection) {
              this.yearSelected = `${foundSelection}`;
            } else {
              // If current selection not found, use the last valid option
              this.yearSelected = `${this.options.yearStep[this.options.yearStep.length - 1]}`;
            }
          } else {
            // If no valid options, set a reasonable default
            this.yearSelected = "1";
          }
        },
        (e) => {
          this.errorMessage = e;
        },
        () => {
          // After year options are loaded, load km options
          this.updateAvailableKms();
        }
      );
  }

  updateAvailableKms() {
    this.options.kmStep = [];
    
    // Only proceed if we have available years
    if (!this.options.yearStep || this.options.yearStep.length === 0) {
      return;
    }
    
    this.matrixCalculatorService
      .getAgreementKms({
        carId: this.usedCarId,
        agreementStartDate: new Date(this.customer.lastservice),
        firstreg: new Date(this.customer.firstreg),
        maxKms: this.dealer.maxKms,
        carKms: (this.customer.actualkm as number) - (this.kmExceeded as number),
        showPartialYears: true,
        untilDate: new Date(this.customer.lastservice),
        currentAgreementKms: this.customer.serviceAgreeKm,
        maxLength: this.dealer.maxYears
      })
              .subscribe(
          (p) => {
            // Ensure p.kms is an array
            if (!p.kms || !Array.isArray(p.kms)) {
              this.options.kmStep = [this.kmSelected]; // Use kmDrivenPerYear as fallback
              return;
            }
            
            // Filter out invalid km options (like -1)
            this.options.kmStep = p.kms.filter(kms => kms != null && kms !== undefined && Number(kms) > 0 && !isNaN(Number(kms)));
          
          if (this.options.kmStep.length) {
            // Try to find the current selection in valid options
            const foundSelection = this.options.kmStep.find(
              (kms) => Number(kms) === Number(this.kmSelected)
            );
            
            if (foundSelection) {
              this.kmSelected = foundSelection;
            } else {
              // If current selection not found, round up to the nearest available option
              const sortedKms = [...this.options.kmStep].sort((a, b) => Number(a) - Number(b));
              const nearestKm = sortedKms.find(kms => Number(kms) >= this.kmSelected);
              
              if (nearestKm) {
                this.kmSelected = nearestKm;
              } else {
                // If no higher option found, use the highest available
                this.kmSelected = sortedKms[sortedKms.length - 1];
              }
            }
          }
          
          if (this.options.kmStep.length <= 1 && this.contactDealerAlert == false) {
            this.calculatedPrice = 0;
            this.contactDealerAlert = true;
          }
        },
        (e) => {
          this.errorMessage = e;
        },
        () => {
          // Calculate price after both km and year options are loaded
          this.calculateCatchUpPrice();
        }
      );
  }

  updateSelectedKms(event: number) {
    // Validate the selected km value
    if (event <= 0) {
      this.kmSelected = 15000;
      return;
    }
    
    this.options.yearStep = [...this.firstOptions];
    this.kmSelected = event;
    this.updateAvailableYears();
  }

  updateSelectedYear(event: string) {
    // Validate the selected year value
    if (Number(event) <= 0) {
      this.yearSelected = "1";
      return;
    }
    
    this.options.yearStep = [...this.firstOptions];
    this.yearSelected = event;
    this.updateAvailableKms();
  }

  selectExtendOption(option: any, index: number) {
    this.isActive = index;
    // Update selections based on the extend option
    if (option && option.years) {
      this.yearSelected = option.years.toString();
    }
    if (option && option.km) {
      this.kmSelected = option.km;
    }
    // Trigger recalculation
    this.updateAvailableKms();
  }
  private calculateExpirationDate(startDate: any, years: any): Date {
    if (!startDate || !years) {
      return new Date();
    }
    
    const start = new Date(startDate);
    const yearsNum = typeof years === 'string' ? parseInt(years, 10) : years;
    
    if (isNaN(yearsNum)) {
      return new Date();
    }
    
    const expiration = new Date(start);
    expiration.setFullYear(expiration.getFullYear() + yearsNum);
    return expiration;
  }

  gotoCheckout(): void {
    let newItem: Partial<KmCatchUpAgreement> = {};
    newItem.car = [this.usedcar];
    newItem.customer = this.customerid;
    newItem.years = this.yearSelected;
    newItem.km = ((this.kmSelected as number)*(Number(this.yearSelected))).toString();
    newItem.price = this.calculatedPrice;
    newItem.actualKm = (this.customer.actualkm as number);
    newItem.lastService = this.customer.lastservice;
    newItem.kmExceeded = this.kmRecord.kmDifference;
    newItem.currentServiceAgreementExpiration = this.calculateExpirationDate(this.customer.lastservice, this.yearSelected);
    newItem.currentServiceAgreementKilometers = Number(newItem.km);
    
    sessionStorage.setItem("kmCatchUpAgree", JSON.stringify(newItem));

    top.window.location.href =
      "/#/km-catch-up/order-flow/checkout/" +
      this.customerid + '/' + this.kmRecordId;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
} 


// WEBPACK FOOTER //
// ./src/app/landingpages/kmCatchUp/order-flow/calculator.component.ts